// Check if window width is less than or equal to 768px (considered as tablet or low)
if(window.innerWidth <= 768) {
  document.querySelectorAll(".card-product-alt-image").forEach(alt_image => alt_image.remove());
}
